import { categories } from '@/mocks/homeData';

const topFour = categories.slice(0, 4);
const remaining = categories.slice(4);

export default function CategoriesGrid() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="mb-14 text-center">
          <p className="text-sm font-label tracking-widest uppercase text-foreground-400 mb-4">
            Curated by Category
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950 leading-tight">
            Browse Our{' '}
            <span className="italic text-primary-500">Collections</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-6">
          {topFour.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/50 hover:border-background-300/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={cat.image}
                  alt={`Superbuy Spreadsheet ${cat.name} collection`}
                  title={`${cat.name} - Superbuy Spreadsheet Collection`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <span className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {remaining.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-4 py-2.5 rounded-full bg-background-100 border border-background-200/50 text-sm text-foreground-600 hover:bg-background-200 hover:text-foreground-900 hover:border-background-300/60 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {cat.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}